import type { AssetArticle } from '@repo/types/asset';

import { ArticleCardGroup } from '@/components/article-table/article-card/article-card-group';
import { ArticleCardItem } from '@/components/article-table/article-card/article-card-item';
import { ArticleCardProduct } from '@/components/article-table/article-card/article-card-product';
import { ArticleCardTextLine } from '@/components/article-table/article-card/article-card-textline';

interface Props {
    item: AssetArticle;
    group?: boolean;
    isChildItem?: boolean;
}

export const ArticleCard = ({ item }: Props) => {
    if (!item.referenceId && !item.seqNo) {
        return null;
    }
    if (item.type === 'GROUP') {
        return <ArticleCardGroup item={item} />;
    }
    if (item.type === 'PRODUCT') {
        return <ArticleCardProduct item={item} />;
    }
    if (item.type === 'TEXTLINE') {
        return <ArticleCardTextLine item={item} />;
    }
    return <ArticleCardItem item={item} />;
};
